<template>

  <div class="page-wrapper">

    <v-container v-if="!outerBlock.active && loaded" class="pr-0 pl-0" fluid>

      <ul class="ob-designer">
        <draggable v-model="page.blocks" group="blocks" handle=".handle">
          <li
              class="outer-block-wrapper outer-block "
              :class="{'has_background': block.using_image, 'parallax-background':block.parallax}"
              :style="!block.using_image ? 'background-color:'+block.color+';' : block.image_overlay === true ? 'background: linear-gradient( '+block.image_overlay_color+', '+block.image_overlay_color+' ), url(\''+block.background_image+'\');': 'background: url(\''+block.background_image+'\');'"
              v-for="(block, index) in page.blocks">

            <blocks-options-outer-block
                :block="block"
                :index="index"
                :blocks="page.blocks">
            </blocks-options-outer-block>

            <v-container
                :class="[block.pt ? 'pt-'+block.pt: '', block.pb ? ' pb-'+block.pb: '', block.mt ? ' mt-'+block.mt: '', block.mb ? ' mb-'+block.mb: '']"
                v-if="block.container">

              <v-card color="transparent"
                      flat
                      :height="block.height < 1 ? 'auto': block.height"
              >

                <blocks-inner-block
                    :block="block"
                    :align="block.align"
                    :justify="block.justify"
                    :block_index="index"
                    :blocks="block.inner_blocks">
                </blocks-inner-block>
              </v-card>
            </v-container>
            <div
                :class="[block.pt ? 'pt-'+block.pt: '', block.pb ? ' pb-'+block.pb: '', block.mt ? ' mt-'+block.mt: '', block.mb ? ' mb-'+block.mb: '']"
                v-if="!block.container">
              <v-card color="transparent"
                      :height="block.height < 1 ? 'auto': block.height"
                      flat>
                <blocks-inner-block
                    :block="block"
                    :align="block.align"
                    :justify="block.justify"
                    :block_index="index"
                    :blocks="block.inner_blocks">
                </blocks-inner-block>
              </v-card>
            </div>
          </li>
        </draggable>
      </ul>
    </v-container>
  </div>
</template>

<script>
// import Vue2Filters from 'vue2-filters'
import draggable from 'vuedraggable'
import {mapGetters} from "vuex";
import ntc from "./plugins/ntc"
import BlocksOptionsOuterBlock from "@/components/Blocks/Options/OuterBlock";
import BlocksInnerBlock from "@/components/Blocks/InnerBlock";


export default {
  computed: {
    ...mapGetters({
      'outerBlock': 'outerBlock',
      'position': 'position',
      'historyLoading': 'historyLoading',
      'leadslide_theme': 'leadslide_theme',
    })
  },
  // mixins: [Vue2Filters.mixin],
  props: {
    page: {
      type: [Object],
      required: true,
      default: {}
    },
    save_page: Function,
    save_block: Function
  },
  components: {
    draggable,
    BlocksOptionsOuterBlock,
    BlocksInnerBlock
  },
  data() {
    return {
      loaded: false,
      text_options: false,
      myArray: [],
      media_url: process.env.VUE_APP_MEDIA_URL,
      limit_history: 3,
      history: [],
      redo_history: [],
      builder_interval: false,
      loading_theme: false,
    }
  },
  watch: {
    'outerBlock.active': {
      deep: true,
      handler(nv, ov) {
        let top = this.outerBlock.top;
        if(ov && !nv)
        {
          setTimeout(
              function() {
                window.scrollTo({
                  top: top
                });
              }, 250);
        }
      },
    },
    'page.blocks': {
      deep: true,
      handler(nv, ov) {

        if (!this.historyLoading) {
          console.log('setting History Item');
          this.$store.dispatch('setHistory', nv);
        }
      }
    }
  },
  created() {
    this._init_builder();
  },
  methods: {

    _init_builder() {
      let self = this;
      self.builder_interval = setInterval(function() {
        if(self.leadslide_theme) {
          console.log("Theme loaded close loader");
          clearInterval(self.builder_interval);
          let fonts = self.parseFonts(
              self.leadslide_theme.fonts
          );
          console.log("FONTS!");
          console.log(self.leadslide_theme)

          let colors = self.parseColors(
              self.leadslide_theme.colors
          );

          self.$store.dispatch('setConfigStyles', {
            fonts:fonts,
            colors: colors
          });

          self.load_blocks();
          self.loaded = true;
          self.$store.dispatch('setLoading', {loading: false, message: ""});
        }
        self.$store.dispatch('setHistory', self.page.blocks);
      }, 1000);
    },
    parseColors(colors) {
      ntc.init();
      let color_arr = [];
      for (const index in colors) {
        let color_code = colors[index]["color"];
        let color_details = ntc.name(color_code);
        let sp_name = color_details[1];
        color_arr.push(color_code.replace("#", ""));
        color_arr.push(sp_name);
      }
      console.log(color_arr)
      return color_arr;
    },
    parseFonts(fonts) {
      let font_string = "";
      for (const index in fonts) {
        let font_parts = [];
        if(typeof fonts[index].css !== 'undefined')
        {
          font_parts = fonts[index].css.split(',')
        } else {
          font_parts = fonts[index].split(',')
        }
        let addon_string = font_parts[0] + "=" + fonts[index].css + ";"
        font_string += addon_string;
      }
      return font_string;
    },
    getColors() {

    },

    load_blocks() {
      this.$store.dispatch('getBlocks', this.id).then(data => {
        this.blocks = data.outer_blocks;
      }).catch((error) => {
        console.log(error);
        this.$notify({
          title: 'Error:',
          text: 'Block load error',
          group: 'notifications',
          position: 'top right'
        });
      });
    },
    open_ib_opts(ib) {

    },
    clone: function (el) {
      return {
        name: el.name + " cloned"
      };
    },
    log: function (evt) {
      window.console.log(evt);
    }
  }
}
</script>
